import './CAPage.less';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import _ from 'lodash';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import EscapeHatch from '../../components/EscapeHatch/EscapeHatch';
import { trackTransition } from '../../../framework/store/FPTI/FPTIActions';
import CompletePopup from './CompletePopup/CompletePopup';
import CreditDetailsPopup from './CreditDetailsPopup/CreditDetailsPopup';
import { approvalPopupClose } from './CAPageActions';
import CAPageForm from './CAPageForm/CAPageForm';
import { FLOW_TYPE } from '../../../framework/App/AppConstants';
import PageHeaderText from '../../../shared-components/Typography/PageHeaderText';
import { popupWithHTML } from '../../../framework/App/AppUtils';
import { reportFCI } from '../../../framework/store/ReportFCI/ReportFCIActions';
import { setServerData } from '../../../framework/store/ServerData/ServerDataActions';
import { PAGE_NAME } from '../../../../../public/js/GB/config/GBConstants';
import { push } from 'connected-react-router';


const LOCALE_PREFIX = 'GB/pages/CAPage/CAPage';

export class CAPage extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        showEscapeHatch: PropTypes.bool,
        showCompletePopup: PropTypes.bool,
        onComponentDidMount: PropTypes.func.isRequired,
        flow: PropTypes.string,
        htmlSecci: PropTypes.string,
        htmlContract: PropTypes.string,
        creditLine: PropTypes.string,
        purchaseApr: PropTypes.string,
        isApprovalPopupVisible: PropTypes.bool,
        onCloseApprovalPopup: PropTypes.func.isRequired,
        onEmptyString: PropTypes.func,
    };
    static defaultProps = {
        onComponentDidMount: () => {}
    };

    componentDidMount() {
        const { htmlSecci, creditLine, onEmptyString, htmlContract, purchaseApr } = this.props;
        this.props.onComponentDidMount();
        
        if (!_.isString(htmlContract) || _.trim(htmlContract) === '') {
            return onEmptyString('Error loading HTML Contract');
        }
        if (!_.isString(htmlSecci) || _.trim(htmlSecci) === '') {
            return onEmptyString('Error loading HTML Secci');
        }
        if (!_.isString(creditLine) || _.trim(creditLine) === '') {
            return onEmptyString('Error no credit line value');
        }
        if (!_.isString(purchaseApr) || _.trim(purchaseApr) === '') {
            return onEmptyString('Error no purchaseApr');
        }
    }

    secciHtmlLink = flow => {
        if (flow === FLOW_TYPE.VENICE) {
            return (
                <a href="seccihtml">
                    <FormattedMessage id={`${LOCALE_PREFIX}.reviewSECCI2`} />
                </a>
            );
        } else {
            return (
                <a href="#" onClick={this.showSecciPopup}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.reviewSECCI2`} />
                </a>
            );
        }
    };

    preFormContent = flow => (
        <div className="CAPage-preForm">
            <h4 className="vx_text-3 CAPage-preForm-title">
                <FormattedMessage id={`${LOCALE_PREFIX}.title`} />
            </h4>
            <PageHeaderText>
                <FormattedMessage id={`${LOCALE_PREFIX}.subtitle`} />
            </PageHeaderText>
            <p className="CAPage-preForm-review-secci vx_text-body">
                <FormattedMessage id={`${LOCALE_PREFIX}.reviewSECCI1`} /> {this.secciHtmlLink(flow)}
            </p>
        </div>
    );

    showSecciPopup = event => {
        event.preventDefault();
        popupWithHTML({
            title: 'ConsumerCreditInfo',
            html: this.props.htmlSecci
        });
    };

    handleCloseApprovalPopup = event => {
        return this.props.onCloseApprovalPopup('approval-popup', event);
    };

    render() {
        const { intl, showEscapeHatch, showCompletePopup, flow,
            isApprovalPopupVisible, creditLine } = this.props;
        const isXOFlow = (flow === FLOW_TYPE.HERMES || flow === FLOW_TYPE.PROX);

        const showCreditDetails = () => isApprovalPopupVisible;

        return (
            <div className="outerWrapper gb-wrapper">
                <div id="wrapper">
                    <div id="main">
                        <div id="CAPage">
                            {(flow !== FLOW_TYPE.TESLA) && <Header singleColumnLayout={true} />}
                            <div id="content">
                                <div id="content-child" className="container row-fluid table-layout CAPage-content">
                                    <section className="contentSection">
                                        {this.preFormContent(flow)}
                                        <CAPageForm />
                                    </section>
                                </div>
                                {showCompletePopup && (
                                    <CompletePopup />
                                )}
                            </div>
                            {showCreditDetails() && (
                                <CreditDetailsPopup
                                    onClose={this.handleCloseApprovalPopup}
                                    creditLine={creditLine}
                                    flow={flow}
                                />
                            )}
                        </div>
                    </div>
                </div>
                <Footer showCancelUrl={isXOFlow} />

                {showEscapeHatch && (
                    <EscapeHatch
                        headerText={intl.formatMessage({ id: `${LOCALE_PREFIX}.escapeHatch.header` })}
                        bodyText1={intl.formatMessage({ id: `${LOCALE_PREFIX}.escapeHatch.body1` })}
                        continueText={intl.formatMessage({ id: `${LOCALE_PREFIX}.escapeHatch.continue` })}
                        cancelText={intl.formatMessage({ id: `${LOCALE_PREFIX}.escapeHatch.cancel` })}
                    />
                )}

            </div>
        );
    }
}

export const mapStateToProps = state => ({
    showEscapeHatch: _.get(state, 'escapeHatch.showEscapeHatch'),
    showCompletePopup: _.get(state, 'serverData.showCompletePopup', false),
    flow: _.get(state, 'serverData.flow'),
    htmlSecci: _.get(state, 'serverData.decisionModel.htmlSecci', ''),
    htmlContract: _.get(state, 'serverData.decisionModel.html_contract', ''),
    isApprovalPopupVisible: _.get(state, 'isApprovalPopupVisible'),
    shouldShowApprovalPopup: _.get(state, 'serverData.decisionModel.shouldShowApprovalPopup', true),
    creditLine: _.get(state, 'serverData.decisionModel.creditLine.format'),
    purchaseApr: _.get(state, 'serverData.decisionModel.purchaseApr')
});

export const mapDispatchToProps = dispatch => ({
    onComponentDidMount() {
        dispatch(trackTransition('pp_credit_seccipage', 'prepare_pp_credit_seccipage'));
        dispatch(trackTransition('pp_credit_contractpage', 'prepare_pp_credit_contractpage'));
    },
    onCloseApprovalPopup(pageName, e) {
        dispatch(approvalPopupClose());
    },
    onEmptyString(errorMessage) {
        const errorModel = {
            message: errorMessage,
        };
        dispatch(setServerData({ errorModel }));
        dispatch(push(PAGE_NAME.ERROR_PAGE));
        dispatch(reportFCI());
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CAPage));
